"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ActionPage;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Text_1 = __importDefault(require("../Text"));
const Image_1 = __importDefault(require("../Image"));
const variables_1 = __importDefault(require("../../styles/variables"));
const PageWithNavbar_1 = __importDefault(require("../PageWithNavbar/PageWithNavbar"));
const clsx_1 = __importDefault(require("clsx"));
const useStyles = (0, core_1.makeStyles)((theme) => ({
    page: {
        backgroundColor: variables_1.default.colors.white,
        padding: 0,
    },
    header: {
        fontWeight: 600,
        color: variables_1.default.colors.grey5,
        margin: '2.25rem 0 1.5rem 0',
        [theme.breakpoints.down('xs')]: {
            marginTop: '3rem',
        },
    },
    body: {
        fontWeight: 500,
        color: variables_1.default.colors.text.default,
    },
    button: {
        margin: '0.5rem',
    },
    buttonText: {
        fontWeight: 600,
    },
    buttonsContainer: {
        marginTop: '2.5rem',
    },
    image: {
        width: '60vw',
        height: '35vh',
        maxWidth: '500px',
        margin: '0.25rem 0 ',
    },
}));
function ActionPage({ pageTitle, header, body, imgSrc, imgAlt, buttons, imageClassName, }) {
    const classes = useStyles();
    (0, react_1.useEffect)(() => {
        if (pageTitle) {
            window.document.title = pageTitle;
        }
    }, [pageTitle]);
    let bodyToRender = body;
    if (typeof body === 'string')
        bodyToRender = (react_1.default.createElement(Text_1.default, { center: true, as: "h4", className: classes.body, "data-testid": "body" }, body));
    return (react_1.default.createElement(PageWithNavbar_1.default, { withLoginButton: true },
        react_1.default.createElement(core_1.Grid, { container: true, direction: "column", alignContent: "center" },
            imgSrc && (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "column", alignItems: "center" },
                react_1.default.createElement(Image_1.default, { src: imgSrc, alt: imgAlt, className: (0, clsx_1.default)(classes.image, imageClassName), "data-testid": 'img' }))),
            header && (react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(Text_1.default, { center: true, as: "h2", className: classes.header, "data-testid": "header" }, header))),
            bodyToRender && react_1.default.createElement(core_1.Grid, { item: true }, bodyToRender),
            buttons && (react_1.default.createElement(core_1.Grid, { item: true, container: true, direction: "row", alignItems: "center", justifyContent: "center", className: classes.buttonsContainer }, buttons)))));
}
